import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SelectDropdown, Td } from '@makyoapp/makyo-ui'

import { ORG_ROLE_OPTIONS, TEAM_ROLE_OPTIONS } from '@/shared/constants'

interface RoleDropdownTdProps<Role> {
  id: string
  className?: string
  /**
   * will be refactored once backend standard ready
   */
  role: Role
  /**
   * is for org?
   */
  isTeam?: boolean
  /**
   * is disabled
   */
  disabled?: boolean
  /**
   * on change
   */
  onChange?: (opt: Role, isTeam: boolean) => void
}

/**
 * item for each team detail table cell
 *
 */
export function RoleDropdownTd<Role extends string>({
  id,
  className,
  role,
  disabled,
  isTeam,
  onChange,
}: RoleDropdownTdProps<Role>) {
  const [curRole, setRole] = useState<Role>(role)
  const { t } = useTranslation()

  return (
    <Td>
      <SelectDropdown
        id={id}
        disabled={disabled}
        menuClassName='dark:bg-slate-900 text-m-m text-zinc-700 dark:text-slate-300 w-[140px]'
        menuSubContainerClassName='rounded-sm overflow-x-hidden'
        toggleClassName='w-[140px]'
        menuFullWidth={false}
        portalMenu={false}
        outlined={true}
        value={curRole}
        onChange={(opt) => {
          if (opt !== curRole) {
            setRole(opt)
            onChange?.(opt, isTeam === true)
          }
        }}
        className={className}
        renderOption={(opt) => t(opt)}
        options={!isTeam ? (ORG_ROLE_OPTIONS as unknown as Role[]) : (TEAM_ROLE_OPTIONS as unknown as Role[])}
      />
    </Td>
  )
}
